module.exports = __webpack_public_path__ + "media/images/flags/to-8ca58268907525aba746c9e252ab9f7d.svg";